export default __webpack_public_path__ + "3cc5860.png";